/* eslint-disable */
// Natural sort for dev_number identifiers like DA99, DA100, DA2226A, DO500.
//
// Problem solved: plain String.localeCompare sorts "DA100" BEFORE "DA99"
// because it compares character-by-character lexicographically — '1' < '9'
// at position 2. Natural sort parses the numeric part and compares as an
// integer.
//
// Grammar (regex): ^([A-Z]{1,3})(\d+)([A-Z]*)$
//   prefix  — 1-3 uppercase letters (DA, DO, DS, CL, DAS, CLP, etc.)
//   num     — one or more digits
//   suffix  — zero or more trailing uppercase letters (A, B, variants)
//
// Rules (locked 2026-04-23):
//   1 · Non-conforming rows go to the END (and sort alphabetically among
//       themselves). null / undefined / empty string also non-conforming.
//   2 · Base before suffix — DA2226 sorts BEFORE DA2226A because empty
//       suffix compares less than any letter.
//   3 · Case-insensitive — da2226 treated identically to DA2226.
//
// Prefix ordering (string-compare):
//   DA100 < DAS100 < DB100    (shorter prefix wins when all shared chars match)
//   DA100 < DO500 < DS100     (alphabetic across prefixes)

export function parseDevNumber(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const m = s.match(/^([A-Z]{1,3})(\d+)([A-Z]*)$/i);
  if (!m) return null;
  return {
    prefix: m[1].toUpperCase(),
    num:    parseInt(m[2], 10),
    suffix: (m[3] || '').toUpperCase(),
  };
}

export function compareDevNumbers(a, b) {
  const pa = parseDevNumber(a);
  const pb = parseDevNumber(b);

  // Both non-conforming — alphabetic among themselves (case-insensitive)
  if (!pa && !pb) {
    const sa = String(a == null ? '' : a).toUpperCase();
    const sb = String(b == null ? '' : b).toUpperCase();
    if (sa < sb) return -1;
    if (sa > sb) return 1;
    return 0;
  }
  // One non-conforming — it lands at the tail
  if (!pa) return 1;
  if (!pb) return -1;

  // Both conforming — cascade prefix → num → suffix
  if (pa.prefix !== pb.prefix) return pa.prefix < pb.prefix ? -1 : 1;
  if (pa.num    !== pb.num)    return pa.num - pb.num;
  if (pa.suffix !== pb.suffix) return pa.suffix < pb.suffix ? -1 : 1;
  return 0;
}
